import * as React from "react";
import { useTranslation } from "react-i18next";
import { translatedOptions, visT } from "views/components/visualizations/visualizationTranslation";
import BarVisualization from "views/components/visualizations/bar/BarVisualization";
import BarVisualizationConfig, {
  DEFAULT_BARMODE
} from "views/logic/aggregationbuilder/visualizations/BarVisualizationConfig";
import { hasAtLeastOneMetric } from "views/components/visualizations/validations";
import {
  DEFAULT_AXIS_CONFIG,
  axisTypes,
  DEFAULT_AXIS_TYPE
} from "views/logic/aggregationbuilder/visualizations/XYVisualization";
import xyAxisConfigFields, { fromAxisConfig } from "views/components/visualizations/xyAxisConfigFields";
const BAR_MODES = ["group", "stack", "relative", "overlay"];
const BarModeHelp = () => {
  const { t } = useTranslation("aggregation");
  return /* @__PURE__ */ React.createElement("ul", null, BAR_MODES.map((mode) => /* @__PURE__ */ React.createElement("li", { key: mode }, /* @__PURE__ */ React.createElement("h4", null, t(`vis_bar.modes.${mode}`)), t(`vis_bar.mode_help.${mode}`))));
};
const validate = hasAtLeastOneMetric("vis_validation.bar_chart_requires_metric");
const barChart = {
  type: BarVisualization.type,
  get displayName() {
    return visT("vis_types.bar_chart");
  },
  component: BarVisualization,
  config: {
    createConfig: () => ({ barmode: DEFAULT_BARMODE, axisType: DEFAULT_AXIS_TYPE, axisConfig: DEFAULT_AXIS_CONFIG }),
    fromConfig: (config) => {
      var _a, _b;
      return {
        barmode: (_a = config == null ? void 0 : config.barmode) != null ? _a : DEFAULT_BARMODE,
        axisType: (_b = config == null ? void 0 : config.axisType) != null ? _b : DEFAULT_AXIS_TYPE,
        ...fromAxisConfig(config)
      };
    },
    toConfig: (formValues) => BarVisualizationConfig.create(
      formValues.barmode,
      formValues.axisType,
      formValues.showAxisLabels ? formValues.axisConfig : DEFAULT_AXIS_CONFIG
    ),
    fields: [
      {
        name: "barmode",
        get title() {
          return visT("vis_bar.mode");
        },
        type: "select",
        get options() {
          return translatedOptions(BAR_MODES, "vis_bar.modes");
        },
        required: true,
        helpComponent: BarModeHelp
      },
      {
        name: "axisType",
        get title() {
          return visT("vis_common.axis_type");
        },
        type: "select",
        get options() {
          return translatedOptions(axisTypes, "vis_common.axis_types");
        },
        required: true
      },
      ...xyAxisConfigFields
    ]
  },
  capabilities: ["event-annotations"],
  validate
};
export default barChart;
